import { User } from '@/types/user.types';
import { Role } from '@/services/roles.service';

/**
 * Détermine si un utilisateur a le rôle admin via le nom de rôle
 * (indépendant de l'ID auto-incrémenté en base).
 */
export function isAdminUser(
  user?: Pick<User, 'role_id' | 'roleName'> | null,
  role?: Pick<Role, 'name'> | null
): boolean {
  const roleName = (user?.roleName || role?.name || '').toLowerCase();
  return roleName === 'admin';
}
